import React, { FC, useState } from 'react'
import { MinMegaMenuSection, MinNavLink, MinNavLinksWrapper, MinNavSubListItem } from '../style'

//* utils
import { ModuleNames } from '../../../../constants/componentNames.constants'
import { MenuGroup } from '../../../../models/others/menuGroup'
import ImgUtil from '../../../../utils/img.utils'
import { internalLinkHandler, isExternalURL } from '../../../../utils/link.utils'
import formatInlineCode from '../../../../utils/shortTextFormatting'

//* components
import { MENU_STYLES } from '../../../../constants/useCases.constants'
import { TopicCTA } from '../../../../models/topics/cta'
import Button from '../../button'
import Typography from '../../typography'
import WrapperImage from '../../wrapperImage'

type MinNavLinksProps = {
  menuGroups: MenuGroup[]
  uiPathSrc: string
  location: string
  bottomText: string
  bottomTextCta: TopicCTA
}

type MinMegaNavProps = {}

const AccordionTargetClass = {
  MAIN_ACCORDION: 'MinNav__Dropdown_Button',
  SUB_ACCORDION: 'Navbar__Sub_Accordion_Item',
}

const handleAccordionOpen = (event: any, targetClass: string) => {
  const current = event.currentTarget
  const parent = event.currentTarget.parentElement

  const activeAccordion =
    targetClass === 'Navbar__Sub_Accordion_Item' ? 'NavLink__Active' : 'MinNavLink__Active'

  if (current.classList.contains('is-active')) {
    current.classList.remove('is-active')
    parent.classList.remove(activeAccordion)
  } else {
    let menuItems = document.querySelectorAll('.' + targetClass)
    for (let item of menuItems) {
      if (item !== event.currentTarget) {
        const itemParent = item.parentElement
        itemParent?.classList.remove(activeAccordion)
        item.classList.remove('is-active')
      }
    }

    parent.classList.add(activeAccordion)
    current.classList.add('is-active')
  }

  let subAccord = current.nextElementSibling.querySelectorAll('.Navbar__Sub_Accordion')
  for (let item of subAccord) {
    item?.classList.remove('NavLink__Active')
    item.querySelector('.Navbar__Sub_Accordion_Item').classList.remove('is-active')
  }
}

export const MinNavLinks: FC<MinNavLinksProps> = ({ menuGroups, uiPathSrc, location }) => (
  <MinNavLinksWrapper>
    {menuGroups?.map((menuGroup: MenuGroup, i: number) => {
      const { newGroupName, pages, id, menuStyle, bottomText, bottomTextCta } = menuGroup
      return (
        <MinNavLink key={id || i}>
          <button
            className="MinNav__Dropdown_Button Menu-item"
            onClick={e => handleAccordionOpen(e, AccordionTargetClass.MAIN_ACCORDION)}>
            <Typography type="header6" className="MinNav__Link_Name">
              {newGroupName}
            </Typography>
          </button>

          {MinMegaNav(pages, uiPathSrc, i, location, menuStyle, bottomText, bottomTextCta)}
        </MinNavLink>
      )
    })}
  </MinNavLinksWrapper>
)

const MinMegaNav = (
  megaNavDataList: any,
  uiPathSrc: string,
  i: number,
  location: string,
  menuStyle: string,
  bottomText: string,
  bottomTextCta: TopicCTA
) => {
  const [ActiveState, setActiveState] = useState(0)
  const getActiveClass = (index: number, className: string) =>
    ActiveState === index ? className : ''
  return (
    <>
      <ul className="MinNav__Megamenu">
        {megaNavDataList?.map((megaNavData: any, index: number) => {
          const isMainNavBanner = megaNavData?.__typename === ModuleNames.MAIN_NAV_BANNER
          if (!megaNavData || JSON.stringify(megaNavData) === '{}' || isMainNavBanner) return null
          const hasIconLink =
            megaNavData?.pages && megaNavData?.pages[0]?.__typename === ModuleNames.TOPIC_ICON_LINK

          megaNavData.highlightedLinks?.forEach((highlightedLink: any) => {
            highlightedLink.isHighlightedLink = true
          })

          const internalLinkSrc =
            megaNavData?.parentLink?.internalLink?.slug &&
            uiPathSrc + megaNavData?.parentLink.internalLink.slug
          const menuGroupSrc = megaNavData?.parentLink?.externalUrl || internalLinkSrc || '#'
          const menuGroupTarget = isExternalURL(menuGroupSrc) ? '_blank' : '_self'

          const renderListData = (pages: any, moduleNames: string, menulevel: string) => {
            return (
              <>
                {pages?.map(
                  (
                    {
                      menuGroupDescription,
                      newGroupName,
                      pages,
                      highlightedLinks,
                      groupNameColor,
                      __typename,
                    }: any,
                    index: number
                  ) => {
                    if (__typename === moduleNames) {
                      const hasIconLink =
                        pages && pages[0]?.__typename === ModuleNames.TOPIC_ICON_LINK
                      highlightedLinks?.forEach((highlightedLink: any) => {
                        highlightedLink.isHighlightedLink = true
                      })
                      return (
                        <>
                          <MinMegaMenuSection
                            key={megaNavData.id}
                            $textColor={groupNameColor}
                            $hasIconLink={hasIconLink}>
                            {displaySublistComponent(
                              pages,
                              highlightedLinks,
                              newGroupName,
                              menuGroupDescription,
                              uiPathSrc
                            )}
                          </MinMegaMenuSection>
                        </>
                      )
                    }
                  }
                )}
              </>
            )
          }

          return (
            <>
              {menuStyle === MENU_STYLES.TABS &&
              (location.includes('New Header Testing') ||
                location.includes('V3 Header German') ||
                location.includes('V3 Header Chinese') ||
                location.includes('V3 Header Trad Chinese') ||
                location.includes('V3 Header French') ||
                location.includes('V3 Header Korean') ||
                location.includes('V3 Header Portuguese') ||
                location.includes('V3 Header Japanese')) ? (
                <>
                  {megaNavData.newGroupName ? (
                    <li
                      className={`${
                        megaNavData.newGroupName
                      } Navbar__Sub_Accordion ${getActiveClass(index, 'NavLink__Active')}`}>
                      <div
                        className={`Navbar__Sub_Accordion_Item`}
                        onClick={e => handleAccordionOpen(e, AccordionTargetClass.SUB_ACCORDION)}>
                        <Typography type="label" className="Navbar__Sub_Accordion_Name">
                          {megaNavData.newGroupName}
                        </Typography>
                      </div>
                      <div className="Navbar__Sub_Accordion_MenuGroup">
                        <div className="Left-Section">
                          <Typography type="label" className="Navbar__Sub_Accordion_Name">
                            <a
                              href={menuGroupSrc}
                              target={menuGroupTarget}
                              className="Navbar__Section_Content_Link">
                              {megaNavData.newGroupName}
                            </a>
                          </Typography>
                          <Typography type="micro" className="Navbar__Sub_Accordion_Desc">
                            {formatInlineCode(megaNavData.menuGroupDescription)}
                          </Typography>
                          <ul className="menu-tab-content">
                            {renderListData(megaNavData?.pages, ModuleNames.MENU_GROUP, '')}
                          </ul>
                          {megaNavData.bottomText && (
                            <div className="Navbar__Sub_Accordion_All_Link">
                              <Button
                                icon={true}
                                type={'text-link'}
                                theme={'dark'}
                                href={
                                  megaNavData.bottomTextCta?.internalLink
                                    ? internalLinkHandler(megaNavData.bottomTextCta?.internalLink)
                                    : megaNavData.bottomTextCta?.externalUrl || ''
                                }
                                text={formatInlineCode(megaNavData.bottomText)}
                                size="medium"
                                arrowOrientation="right"
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </li>
                  ) : (
                    <li className="TopicIconLink">
                      <>
                        {megaNavData?.icon && (
                          <WrapperImage
                            src={ImgUtil.getResizedImageUrl(
                              megaNavData?.icon?.image?.file?.url,
                              ''
                            )}
                            width={18}
                            alt={megaNavData?.icon?.altText}
                            className="Icon"
                          />
                        )}

                        <Typography type="label">
                          <a
                            href={megaNavData?.url}
                            target={isExternalURL(megaNavData?.url) ? '_blank' : '_self'}
                            className="Navbar__SubList_IconLink">
                            {megaNavData?.ctaText}{' '}
                            {megaNavData?.highlightText && (
                              <span>{megaNavData?.highlightText}</span>
                            )}
                          </a>
                        </Typography>
                      </>
                    </li>
                  )}
                </>
              ) : (
                <MinMegaMenuSection
                  key={megaNavData.id}
                  $textColor={megaNavData.groupNameColor}
                  $hasIconLink={hasIconLink}>
                  {displaySublistComponent(
                    megaNavData?.pages,
                    megaNavData?.highlightedLinks,
                    megaNavData?.newGroupName,
                    megaNavData?.menuGroupDescription,
                    uiPathSrc
                  )}
                </MinMegaMenuSection>
              )}
            </>
          )
        })}
      </ul>
      {bottomText && menuStyle !== 'Tabs' && (
        <div className="MinNav__Accordion_All_Link">
          <Button
            icon={true}
            type={'text-link'}
            theme={'dark'}
            href={
              bottomTextCta?.internalLink
                ? internalLinkHandler(bottomTextCta?.internalLink)
                : bottomTextCta?.externalUrl || ''
            }
            text={formatInlineCode(bottomText)}
            size="medium"
            arrowOrientation="right"
          />
        </div>
      )}
    </>
  )
}

const displaySublistComponent = (
  pages: any,
  highlightedLinks: any,
  newGroupName: string,
  menuGroupDescription: string,
  uiPathSrc: string
) => {
  const pagesWithHighlightedLinks = pages ? pages.concat(highlightedLinks || []) : []
  const mid = Math.ceil(pagesWithHighlightedLinks.length / 2) || 0
  const leftPages = pagesWithHighlightedLinks.slice(0, mid) || []
  const rightPages = pagesWithHighlightedLinks.slice(mid) || []

  const sectionName = (
    <Typography type="label" className="MinNav__Section_Name">
      {newGroupName}
    </Typography>
  )

  const sectionDescription = (
    <Typography type="micro" className="MinNav__Section_Description">
      {formatInlineCode(menuGroupDescription)}
    </Typography>
  )

  return (
    <>
      <div className="MinNav__Section_Content">
        {newGroupName && sectionName}
        {menuGroupDescription && sectionDescription}
      </div>

      {leftPages.length && <div className="SubList__Left">{SubItemList(leftPages, uiPathSrc)}</div>}

      {rightPages.length && (
        <div className="SubList__Right">{SubItemList(rightPages, uiPathSrc)}</div>
      )}
    </>
  )
}

const SubItemList = (subList: any, uiPathSrc: string) =>
  subList?.map((subItem: any) => {
    const {
      internalLink,
      icon,
      ctaText,
      description,
      id,
      __typename,
      isHighlightedLink,
      text,
      highlightText,
    } = subItem

    const internalLinkSrc = internalLink?.slug && uiPathSrc + internalLink.slug
    const subListUrl = subItem?.externalUrl || internalLinkSrc || subItem?.url || '#'
    const target = isExternalURL(subListUrl) ? '_blank' : '_self'

    const iconImg = (
      <WrapperImage
        src={ImgUtil.getResizedImageUrl(subItem?.icon?.image?.file?.url, '')}
        width={18}
        alt={icon?.altText}
      />
    )

    const iconLabel = (
      <Typography type="bodyXS">
        {ctaText} {highlightText && <span>{highlightText}</span>}
      </Typography>
    )

    const iconDescription = (
      <Typography type="micro" className="Navbar__IconLink_Caption">
        {description}
      </Typography>
    )

    return (
      <MinNavSubListItem key={id}>
        {__typename === ModuleNames.TOPIC_ICON_LINK ? (
          <a href={subListUrl} target={target} className="MinNav__SubList_IconLink">
            <div className="MinNav__IconLink_Header">
              {icon && iconImg}
              {ctaText && iconLabel}
            </div>
            {description && iconDescription}
          </a>
        ) : isHighlightedLink ? (
          <Button
            className="MinNav__HighlightedLink"
            icon={true}
            type={'text-link'}
            theme={'light'}
            href={subListUrl}
            text={text}
            size="medium"
            arrowOrientation="right"
          />
        ) : (
          <a href={subListUrl} target={target} className="MinNav__SubList_Cta">
            <Typography type="bodyXS">{text}</Typography>
          </a>
        )}
      </MinNavSubListItem>
    )
  })
